var platforms = [
    {
        os: 'iOS',
        device: 'iPad',
        match: /(?:iPad).*OS\s([\d_]+)/,
    },
    {
        os: 'iOS',
        device: 'iPod',
        match: /(?:iPod)(?:.*OS\s([\d_]+))?/,
    },
    {
        os: 'iOS',
        device: 'iPhone',
        match: /(?:iPhone\sOS)\s([\d_]+)/,
    },
    {
        os: 'Android',
        device: 'Android',
        match: /(?:Android);?[\s\/]+([\d.]+)?/,
    },
    {
        os: 'UNKNOWN',
        device: 'UNKNOWN',
        match: /./,
    },
];
var apps = [
    {
        aid: 1373,
        name: 'faceu_os',
        match: /faceu-os\/([\d+\.]+)/i,
    },
    {
        aid: 10001,
        name: 'faceu',
        match: /faceu\/([\d+\.]+)/i,
    },
    {
        aid: 1372,
        name: 'ulike_os',
        match: /ulike-os\/([\d+\.]+)/i,
    },
    {
        aid: 150121,
        name: 'ulike',
        match: /ulike\/([\d+\.]+)/i,
    },
    {
        aid: 1775,
        name: 'lv',
        match: /lv\/([\d+\.]+)/i,
    },
    {
        aid: 2515,
        name: 'retouch',
        match: /retouch\/([\d\.]+)/i,
    },
    {
        aid: 5032,
        name: 'heycan',
        match: /heycan\/([\d\.]+)/i,
    },
    {
        aid: 1128,
        name: 'aweme',
        match: /aweme_([\d\.]+)/i,
    },
    {
        aid: 0,
        name: 'qq',
        match: /QQ/i,
    },
    {
        aid: 0,
        name: 'weibo',
        match: /WeiBo/i,
    },
    {
        aid: 0,
        name: 'wechat',
        match: /micromessenger/i,
    },
    {
        aid: 0,
        name: 'UNKNOWN',
        match: /(\d)/,
    },
];

/** parse ua and generate env information */
function parseEnv(ua) {
    var app = apps.find(function (v) { return v.match.test(ua); });
    var platform = platforms.find(function (v) { return v.match.test(ua); });
    // find nth item in array, use dft if missing.
    var nth = function (arr, idx, dft) {
        return arr && arr[idx] !== void 0 ? arr[idx] : dft;
    };
    return {
        aid: app.aid,
        appName: app.name,
        appVersion: nth(app.match.exec(ua), 1, '0'),
        osName: platform.os,
        osVersion: nth(platform.match.exec(ua), 1, '0').replace(/_/g, '.'),
        isIOS: platform.os === 'iOS',
        isAndroid: platform.os === 'Android',
        isProd: !window || !/boe/.test(location.origin),
    };
}
var env = parseEnv(window ? window.navigator.userAgent : '');

export default env;
//# sourceMappingURL=index.js.map
